module.exports = __webpack_public_path__ + "media/assets/images/seedling-5ed05b45f856288bd105f260b0f2badf.svg";